module.exports = __webpack_public_path__ + "assets/img/be8207ba757499ce4109c8625d435673.svg";